import React, { createContext, useContext, useState, useEffect } from 'react';

const ViewOnlyContext = createContext();

export const ViewOnlyProvider = ({ children }) => {
  // Initialize state from sessionStorage if available
  const [viewOnlyMode, setViewOnlyMode] = useState(() => {
    const stored = sessionStorage.getItem('viewOnlyMode');
    return stored ? JSON.parse(stored) : false;
  });
  
  const [viewerInfo, setViewerInfo] = useState(() => {
    const stored = sessionStorage.getItem('viewerInfo');
    return stored ? JSON.parse(stored) : null;
  });

  // Persist to sessionStorage whenever state changes
  useEffect(() => {
    sessionStorage.setItem('viewOnlyMode', JSON.stringify(viewOnlyMode));
  }, [viewOnlyMode]);

  useEffect(() => {
    sessionStorage.setItem('viewerInfo', JSON.stringify(viewerInfo));
  }, [viewerInfo]);

  const enableViewOnlyMode = (dependentName) => {
    setViewOnlyMode(true);
    setViewerInfo({ name: dependentName, type: 'dependent' });
  };

  const disableViewOnlyMode = () => {
    setViewOnlyMode(false);
    setViewerInfo(null);
    // Also clear sessionStorage
    sessionStorage.removeItem('viewOnlyMode');
    sessionStorage.removeItem('viewerInfo');
    sessionStorage.removeItem('viewOnlyBaby');
  };

  return (
    <ViewOnlyContext.Provider value={{ 
      viewOnlyMode, 
      viewerInfo,
      enableViewOnlyMode, 
      disableViewOnlyMode 
    }}>
      {children}
    </ViewOnlyContext.Provider>
  );
};

export const useViewOnly = () => {
  const context = useContext(ViewOnlyContext);
  if (!context) {
    throw new Error('useViewOnly must be used within ViewOnlyProvider');
  }
  return context;
};
